import { atom } from 'recoil'

const search_address_atom = atom<string>({
  key: '@window/search/map/value/address',
  default: '',
})

export default search_address_atom
